import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseCustomerDropDownNew = (url,search) => {
    const [data, setDataCustomer] = useState([]);

    async function getData() {
        axiosInstance.get(url,{params:{search:search}}).then(res => {
            // console.log('daataa',res.data?.data);
            let data = res.data;
            console.log(data,'dddd');
            let tempData = [];
            data.forEach((item) => {
                let tempObject = { value: item.id, label: item.name };
                tempData.push(tempObject);
            });
            res.data && setDataCustomer(tempData);
        }).catch(err => {
            console.log(err, "err");
        })
    }
    //     try {
    //       const res = await axiosInstance.get(url);
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    useEffect(() => {
        getData();
    }, [url,search]);

    return { data , setDataCustomer };
};

export default UseCustomerDropDownNew